import { PdpProductSizeType, RecommendOptionValueList, SizeRecommendation } from '@domains/pdp-common';

import { RecommendOptionValueModel, SizeRecommendationModel } from './types';

export function toSizeRecommendation(data?: SizeRecommendation | null): SizeRecommendationModel {
  return {
    recommendationType: data?.recommendation_type || PdpProductSizeType.NONE,
    recommendOptionValueList: toRecommendOptionValueList(data?.option_value_list || []),
    userAccount: {
      name: data?.user_account?.name || '',
      body: {
        height: data?.user_account?.body?.height || 0,
        weight: data?.user_account?.body?.weight || 0,
        sizeText: data?.user_account?.body?.size_text || '',
      },
    },
  };
}

export function toRecommendOptionValueList(list: Array<RecommendOptionValueList>): Array<RecommendOptionValueModel> {
  return list.map((item) => {
    return {
      ranking: item.ranking || 0,
      name: item.name || '',
      heightRange: {
        min: item.height_range?.min || 0,
        max: item.height_range?.max || 0,
      },
      weightRange: {
        min: item.weight_range?.min || 0,
        max: item.weight_range?.max || 0,
      },
      sizeWithCategory: item.size_with_category || '',
      answer: {
        percent: item.answer?.percent || 0,
        value: item.answer?.value || '',
      },
      purchasePercent: item.purchase_percent || 0,
    };
  });
}
